import { fetcher } from '../../../../scripts/utils/fetch.js';
import Urls from '../urls.js';

export default class AddToCartBundles {
	constructor({ btnSelector }) {
		this.btns = document.querySelectorAll(btnSelector);

		if (!!this.btns.length) {
			this.addListeners();
		}
	}

	addListeners () {
		this.btns.forEach(elem => elem.addEventListener('click', this.addToCart.bind(this)));
	}

	addToCart (event) {
		const btn = event.currentTarget;
		const BundleId = btn.getAttribute('data-bundle-id');

		btn.classList.add('progress');
		btn.setAttribute('disabled', true);

		fetcher(Urls.Api.bundle, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ BundleId })
		})
		.then(response => {
			const product_added_event = new CustomEvent('[add-to-cart]:product-added', { detail: response });

			this.goToCart();

			document.dispatchEvent(product_added_event);
		});
	}

	goToCart() {
		window.location.href = Urls.Api.cart;
	}
}